import { render } from "./SessionsSection.vue?vue&type=template&id=b7477b22&scoped=true"
import script from "./SessionsSection.vue?vue&type=script&lang=js"
export * from "./SessionsSection.vue?vue&type=script&lang=js"

import "./SessionsSection.vue?vue&type=style&index=0&id=b7477b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7477b22"]])

export default __exports__